import { render, staticRenderFns } from "./companyaccountmain.vue?vue&type=template&id=361239a7&"
import script from "./companyaccountmain.vue?vue&type=script&lang=js&"
export * from "./companyaccountmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports